import { Reveal } from "../site/Motion";
import { SectionLabel } from "../site/Bits";
import { WHY_CHOOSE } from "../../lib/site";

export const WhyChoose = () => (
  <section id="why" className="relative scroll-mt-24 overflow-hidden bg-ink py-28 text-white" data-testid="why-section">
    <div className="grid-lines pointer-events-none absolute inset-0 opacity-[0.07]" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-3xl">
        <SectionLabel dark>Why choose RenewTracker</SectionLabel>
        <h2 className="mt-6 font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-6xl">
          A manifesto for staying compliant.
        </h2>
      </Reveal>

      <div className="mt-16 divide-y divide-white/10 border-t border-white/10">
        {WHY_CHOOSE.map((w, i) => (
          <Reveal key={w.n} delay={i * 0.08}>
            <div
              data-testid={`why-item-${w.n}`}
              className="group grid grid-cols-1 gap-4 py-10 md:grid-cols-12 md:gap-8"
            >
              <div className="md:col-span-3">
                <span className="font-display text-6xl font-800 font-extrabold text-white/10 transition-colors duration-300 group-hover:text-brand-light">
                  {w.n}
                </span>
              </div>
              <h3 className="font-display text-2xl font-semibold md:col-span-4 md:text-3xl">{w.title}</h3>
              <p className="text-base leading-relaxed text-white/60 md:col-span-5">{w.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChoose;
